import React, { useEffect, useState } from 'react';
import './ArticlesSection.css';
import { API_BASE } from '../config';


export default function ArticlesSection() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/insights/`)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        setArticles(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load insights:', err);
        setError('Could not load insights.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="articles-section">
        <h2 className="section-title">مقالات اختصاصی</h2>
        <p>Loading…</p>
      </section>
    );
  }

  if (error) {
    return (
      <section className="articles-section">
        <h2 className="section-title">Featured Insights</h2>
        <p className="error">{error}</p>
      </section>
    );
  }

  const shown = articles.slice(-3);
  const placeholdersNeeded = Math.max(0, 3 - shown.length);

  return (
    <section className="articles-section">
      <h2 className="section-title">مقالات اختصاصی</h2>
      <div className="articles-grid">
        {shown.map(a => {
          const imgSrc = a.image?.startsWith('http')
            ? a.image
            : `${API_BASE}${a.image || ''}`;

          // دانلود → PDF file
          const pdfHref = a.file?.startsWith('http')
            ? a.file
            : a.file ? `${API_BASE}${a.file}` : '';
          // مطالعه تحت وب → HTML link
          const webHref = a.link?.startsWith('http') ? a.link : '';
          // عنوان: اول وب، بعد PDF
          const titleHref = webHref || pdfHref || '#';

          return (
            <div className="article-card" key={a.id}>
              {imgSrc && <img src={imgSrc} alt={a.title} className="article-img" />}
              <div className="article-body">
                <h3 className="article-title">
                  <a href={titleHref} target="_blank" rel="noopener noreferrer">
                    {a.title} 
                  </a>
                </h3>
                <p className="article-summary">{a.description}</p>
                <div className="article-footer">
                  {a.category && <span className="article-category">{a.category}</span>}
                  <div className="article-actions">
                    {pdfHref && (
                      <a href={pdfHref} className="read-more" target="_blank" rel="noopener noreferrer">
                        دانلود
                      </a>
                    )}
                    {webHref && (
                      <a href={webHref} className="read-more read-more-web" target="_blank" rel="noopener noreferrer">
                        مطالعه تحت وب
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {Array.from({ length: placeholdersNeeded }).map((_, i) => (
          <div className="article-card article-placeholder" key={`placeholder-${i}`} aria-hidden="true" />
        ))}
      </div>
      <a href="/insights" className="view-all-articles">
        مشاهده تمام مقالات
      </a>
    </section>
  );
}
